import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, message } from '@tencent/ten-design-react';
import { NavBar, Footer } from '../../components';
import errorImage from '@shared/assets/image/error.png';
import { copyToClip } from '@shared/utils';

const propTypes = {
  children: PropTypes.element,
  match: PropTypes.object,
  location: PropTypes.object,
  routerName: PropTypes.string,
  history: PropTypes.object,
};
const { Provider, Consumer } = React.createContext();

class BaseView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMsg: '',
    };
  }
  componentDidMount() {
    const {
      match: { path = '' },
    } = this.props || {};
    console.log('跳转路由到：', path);
  }

  componentDidCatch(error) {
    this.setState({ hasError: true, errorMsg: error });
    console.error(error);
  }

  _copyError = () => {
    // 复制错误，目前没有复制的库，没必要引入，后续如果有其他复制场景考虑加上这里
    copyToClip(this.state.errorMsg, () => {
      message.success('复制成功', 1000);
    });
  };

  _renderError() {
    return (
      <div
        style={{
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={errorImage} style={{ width: '230px', height: '158px' }} alt="错误" />
        <p style={{ marginTop: '20px' }}>
          没有权限，请联系 aoliiwang/ashleyba。
          <span style={{ color: '#1b45ba', cursor: 'pointer' }} onClick={this._copyError}>
            复制错误
          </span>
        </p>
        <Button style={{ marginTop: '20px' }} theme={'primary'} onClick={() => this.props.history.replace('/')}>
          返回首页
        </Button>
      </div>
    );
  }

  render() {
    if (this.state.hasError) {
      return this._renderError();
    }
    const { children } = this.props;
    const element = React.cloneElement(children, { ...this.props });
    return (
      <>
        <NavBar {...this.props} />
        <Provider
          value={{
            router: { match: this.props.match, location: this.props.location, routerName: this.props.routerName },
          }}
        >
          {element}
        </Provider>
        <Footer />
      </>
    );
  }
}

BaseView.propTypes = propTypes;
export default BaseView;

export const BaseViewConsumer = Consumer;
